<template>
  <div class="paramset">
    <el-form
      v-if="status == 2"
      :model="setForm"
      ref="setForm"
      class="demo-ruleForm"
      :rules="formRules"
    >
      <el-form-item label="工作真空" prop="pressure">
        <el-row>
          <el-col :span="5">
            <Keyboard v-model="setForm.pressure">
              <el-input v-model="setForm.pressure"></el-input>
            </Keyboard>
          </el-col>
          <el-col :span="19">
            <div class="form-msg"></div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="脉动比率">
        <el-row>
          <el-col :span="5">
            <el-select v-model="setForm.rate" placeholder="">
              <el-option label="60:40" :value="1"></el-option>
              <el-option label="63:37" :value="2"></el-option>
              <el-option label="65:35" :value="3"></el-option>
              <el-option label="66:34" :value="4"></el-option>
              <el-option label="67:33" :value="5"></el-option>
              <el-option label="68:32" :value="6"></el-option>
            </el-select>
          </el-col>
          <el-col :span="19">
            <div class="form-msg"></div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="脉动频率" prop="cycle">
        <el-row>
          <el-col :span="5">
            <Keyboard v-model="setForm.cycle">
              <el-input v-model="setForm.cycle" :disabled="false"></el-input>
            </Keyboard>
          </el-col>
          <el-col :span="19">
            <div class="form-msg"></div>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item label="&nbsp;">
        <el-button type="primary" @click="submit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { send } from ".././../socket/index";
import Keyboard from "@/components/keyboard/index.vue";

export default {
  name: "Page",
  components: { Keyboard },
  data() {
    return {
      status: 0,
      setForm: {},
      formRules: {
        pressure: [{ required: true, message: "必填" }],
        cycle: [{ required: true, message: "必填" }],
      },
    };
  },
  methods: {
    async submit() {
      this.$refs.setForm.validate(async (valid) => {
        if (valid) {
          try {
            let res = await this.$myRequest({
              url: "/saveParamSetReq",
              method: "post",
              data: this.setForm,
            });
            res = res.data;
            this.init();
          } catch (err) {
            console.log(err);
          }

        } else {
          return false;
        }
      });
    },
    async init() {
      try {
        let res = await this.$myRequest({
          url: "/getParamSetReq",
          method: "post",
        });
        res = res.data;
        this.setForm = res.data;
        this.status = 2;
      } catch (err) {
        console.log("err form init");
        console.log(err);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
